module.exports = __webpack_public_path__ + "static/media/blom-pysanky-93.89f11baa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/blom-pysanky/blom-pysanky-93.jpg
// module id = 3787
// module chunks = 15